import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EneTooltipComponent } from "./tooltip.component";
import { EneTooltipDirective } from "./tooltip.directive";

@NgModule({
  declarations: [EneTooltipDirective, EneTooltipComponent],
  imports: [CommonModule],
  exports: [EneTooltipDirective]
})
export class EneTooltipModule {}
